/* ------------------------------------------------------------------------ */
/*		File: cmpLink.tsx                                                   */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { ICard } from "./cmpLink.d";
import { getImage } from "../GenericComponents/functions";
import "./cmpLink.css";

/* ------------------------------------------------------------------------ */

const Links: React.FC<ICard> = ({card, onClick}) => {
    return (
        <div 
            className="card_link"
            onClick={() => onClick!(card.url)}
        >
            <img className="card_link_image" src={getImage(card.src)} alt={card.src} />
            <div 
                className="card_link_label"
                dangerouslySetInnerHTML={{ __html: card.label! }}
            />
            <img className="card_link_image" src={getImage(card.src)} alt={card.src} />
        </div>
    );
};

export default Links;